<!--  OLD LOGIN SCREEN -->

<!-- <div class="login-wrapper">
  <div class="w-100 globalNav">
      <div class="navbar-area sticky-top">
          <div class="main-nav">
              <div class="w-100 header_home_main">
                  <nav class="navbar navbar-expand-md navbar-light">
                      <a class="navbar-brand" href="index.html">
                          <img src="assets/SCRAII_Logo.png" alt="Logo" />
                      </a>
                  </nav>
              </div>
          </div>
      </div>
  </div>

  <div class="login-container">
      <div class="row mx-0">
          <div class="col-xl-6 col-lg-8 col-md-9 col-sm-12 card flex-row mx-auto px-0">
              <div class="img-left d-none d-md-flex"></div>
              <div class="card-body">
                  <div [hidden]='!loginMode'>
                      <div class="col-lg-12 col-sm-12 col-12 p-0">
                          <h4 class="title mt-4">
                              Login
                          </h4>
                          <p class="font12">Welcome to SCRAII. Please enter your login
                              credentials.</p>
                      </div>

                      <div class="col-lg-12 col-sm-12 col-12 form-box p-0">
                          <form #f="ngForm">
                              <div class="form-input">
                                  <label>Username</label>
                                  <input type="email" [(ngModel)]='username' placeholder="Enter your email address"
                                      name="username" required>
                              </div>
                              <div class="form-input">
                                  <label>Password</label>
                                  <input type="password" [(ngModel)]='password' placeholder="Enter your password"
                                      name="password" required>
                              </div>
                              <div class="col-lg-12 col-sm-12 col-12 my-2 p-0">
                                  <div class="text-right">
                                      <a href="javascript:void(0)" class="forget-link"
                                          (click)="showResetPassword()">Forgot Password?</a>
                                  </div>
                              </div>
                              <button type="submit" class="btn btn-block" (click)="login(f)" [disabled]="isLoggingIn">Login</button>
                          </form>

                          <div>
                              {{message}}
                          </div>
                      </div>
                  </div>

                  <div [hidden]='!firstTimeReset'>
                      <div class="col-lg-12 col-sm-12 col-12">
                          <h4 class="title text-center mt-4">
                              Reset Password
                          </h4>
                          <br />
                      </div>

                      <div class="col-lg-12 col-sm-12 col-12 form-box">
                          <form>
                              <div class="form-input">
                                  <label>New password</label>
                                  <input type="password" [(ngModel)]='new_password' placeholder="Enter new password"
                                      name="newPassword" required>
                              </div>
                              <div class="form-input">
                                  <label>Confirm password</label>
                                  <input type="password" [(ngModel)]='confirm_password'
                                      placeholder="Enter confirm password" name="confirmPassword" required>
                              </div>
                              <button type="submit" class="btn btn-block" (click)="resetPassword()">Reset</button>
                              <br />{{messageResetPassword}}
                          </form>
                      </div>

                      <div class="col-lg-12 col-sm-12 col-12 my-3 p-0 m-0">
                          <div class="text-right">
                              <a href="javascript:void(0)" class="forget-link nextIcon" (click)="showLogin()">
                                  <span class="mr-2">Go to login form</span> <span class="arrow"></span>
                              </a>
                          </div>
                      </div>
                  </div>

                  <div [hidden]='!forgotMode'>
                      <div class="col-lg-12 col-sm-12 col-12">
                          <h4 class="title mt-4 mb-3">
                              Set new password
                          </h4>
                      </div>

                      <div class="col-lg-12 col-sm-12 col-12 form-box">
                          <form>
                              <div class="form-input">
                                  <label>Email</label>
                                  <input type="email" [(ngModel)]='forgot_email' placeholder="Enter email"
                                      name="forgotEmail" required>
                              </div>
                              <button type="submit" class="btn btn-block" (click)="sendVerificationCode()">Send
                                  verification code</button>
                          </form>
                      </div>

                      <div class="col-lg-12 col-sm-12 col-12 my-3">
                          <div class="text-left">
                              <a href="javascript:void(0)" class="forget-link backIcon" (click)="showLogin()">
                                  <span class="arrow"></span>
                                  <span class="ml-4">Back to login</span>
                              </a>
                          </div>
                      </div>
                  </div>

                  <div [hidden]='!resetMode'>
                      <div class="col-lg-12 col-sm-12 col-12">
                          <h4 class="title mt-4 mb-3">
                              Reset password
                          </h4>
                      </div>

                      <div class="col-lg-12 col-sm-12 col-12 form-box">
                          <form>
                              <div class="form-input">
                                  <label>Verification code</label>
                                  <input type="text" [(ngModel)]='verification_code'
                                      placeholder="Enter verification code" name="verificationCode" required>
                              </div>
                              <div class="form-input">
                                  <label>New password</label>
                                  <input type="password" [(ngModel)]='new_update_password'
                                      placeholder="Enter new password" name="newPassword" required>
                              </div>
                              <button type="submit" class="btn btn-block" (click)="updatePassword()">Update
                                  password</button>
                              <div>
                                  {{updatePasswordMessage}}
                              </div>
                          </form>
                      </div>

                      <div class="col-lg-12 col-sm-12 col-12 my-3 p-0 m-0">
                          <div class="text-right">
                              <a href="javascript:void(0)" class="forget-link nextIcon" (click)="showLogin()">
                                  <span class="mr-2">Go to login form</span> <span class="arrow"></span>
                              </a>
                          </div>
                      </div>
                  </div>

                  <div [hidden]='!mfaMode'>
                      <div class="col-lg-12 col-sm-12 col-12 user-name">
                          <strong>MFA Verification</strong>
                      </div>
                      <br />
                      <div class="col-lg-12 col-sm-12 col-12 form-input">
                          <form>
                              <div *ngIf="showQR">
                                  <div>Please scan this code to setup MFA</div>
                                  <qrcode [qrdata]="qrValue" [width]="128" [errorCorrectionLevel]="'M'"></qrcode>
                              </div>
                              <div class="form-group">
                                  <mat-form-field appearance="standard">
                                      <label>Enter verification code</label>
                                      <input type="text" [(ngModel)]="mfa_answer" name="verificationCode" matInput
                                          required>
                                  </mat-form-field>
                              </div>
                              <button type="submit" class="btn btn-primary" (click)="verifyMFA()">Verify MFA</button>
                              <div class="text-danger">
                                  <br />{{mfaMessage}}
                              </div>
                          </form>
                          <br />
                      </div>

                      <div class="col-lg-12 col-sm-12 col-12 link-part">
                          <a href="javascript:void(0)" (click)="showLogin()">Login form</a>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div> -->





<!--  NEW LOGIN SCREEN -->
<div class="container-fluid">
    <div class="row">
        <!-- Login Form Block -->
        <div class="du_login_box col-lg-6 col-xs-12 col-sm-12 col-md-6 d-flex flex-column justify-content-between"
            style="height:100vh;height:100dvh">
            <!-- SCRAII LOGO -->
            <div class="row mt-2 pl-4 laptopview">
                <img class="pt-2" src="../../../../assets/SCRAII_LoginLogo.svg" style="width: 25%" />
            </div>
            <div class="row for_mobile_tab mt-5">
                <div class="col-12 d-flex"
                    style="width: -webkit-fill-available;justify-content: center;align-items: center;">
                    <img class="pt-2 scraii_mob_logo" src="../../../../assets/scraii_mobile_logo.svg" />
                    <div class=" ml-1 scraii_txt_mobile" style="font-size: large;margin-top: 13px;">SCRAII</div>
                </div>
                <div class="col-12 mt-3 d-flex flex-column"
                    style="width: -webkit-fill-available;justify-content: center;align-items: center;">
                    <div class=" ml-1 power_txt_mobile">POWERING PATIENT ENGAGEMENT</div>
                    <div class="ml-1 mt-2 show_subContent" style="font-size: smaller;">Provide powerful insights to
                        brand and patient services leaders</div>
                </div>
            </div>
            <!-- LOGIN FORM -->
            <div class="row d-flex justify-content-center form_mobile mr-0 mb-0"
                style="width: -webkit-fill-available;top: 25%;position: absolute;width: 100%;;">
                <div class="card shadow-lg w-75">
                    <div class="text-right p-2" style="position: absolute;right: 0;">
                        <span style="cursor: pointer;" [matMenuTriggerFor]="info" (click)="helpInfo()">
                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect x="1" y="1" width="26" height="26" rx="13" fill="white" stroke="#E8EAEE"
                                    stroke-width="2" />
                                <path
                                    d="M16.8233 17.1765C14.3135 19.6863 13.7801 19.7803 10.9998 17C8.21943 14.2197 8.31042 13.6893 10.9998 11C13.6891 8.31065 14.1206 8.12086 16.9998 11C19.8789 13.8791 19.7801 14.2197 16.8233 17.1765Z"
                                    fill="#1363DF" />
                                <path
                                    d="M13.9998 12.0983C14.1462 12.0983 14.2649 11.9796 14.2649 11.8332C14.2649 11.6867 14.1462 11.568 13.9998 11.568C13.8533 11.568 13.7346 11.6867 13.7346 11.8332C13.7346 11.9796 13.8533 12.0983 13.9998 12.0983Z"
                                    fill="white" />
                                <path
                                    d="M13.4998 16.341C13.4998 16.6171 13.7236 16.841 13.9998 16.841C14.2759 16.841 14.4998 16.6171 14.4998 16.341H13.4998ZM14.4998 14.2197C14.4998 13.9435 14.2759 13.7197 13.9998 13.7197C13.7236 13.7197 13.4998 13.9435 13.4998 14.2197H14.4998ZM16.4697 16.8229C15.8404 17.4522 15.3634 17.9005 14.9552 18.1916C14.5517 18.4794 14.2671 18.5753 14.0195 18.5721C13.7679 18.5688 13.4622 18.4622 13.0203 18.1466C12.5769 17.8299 12.0477 17.3408 11.3533 16.6464L10.6462 17.3535C11.342 18.0493 11.9221 18.5911 12.4391 18.9603C12.9576 19.3306 13.4634 19.5649 14.0065 19.572C14.5535 19.5791 15.0466 19.3547 15.5358 19.0058C16.0204 18.6602 16.5512 18.1556 17.1768 17.53L16.4697 16.8229ZM11.3533 16.6464C10.6584 15.9515 10.1704 15.4237 9.85723 14.9796C9.54619 14.5385 9.44498 14.2315 9.44859 13.9728C9.45221 13.7127 9.56296 13.4085 9.87839 12.9754C10.1957 12.5398 10.6791 12.0277 11.3533 11.3535L10.6462 10.6464C9.97573 11.3169 9.43931 11.8797 9.07004 12.3867C8.69891 12.8963 8.45643 13.4027 8.44868 13.9589C8.44091 14.5165 8.67019 15.0315 9.04001 15.5559C9.40766 16.0772 9.95094 16.6583 10.6462 17.3535L11.3533 16.6464ZM11.3533 11.3535C12.0303 10.6766 12.5373 10.1858 12.9687 9.85919C13.3986 9.53378 13.6933 9.41898 13.9433 9.4116C14.1902 9.40431 14.4905 9.49918 14.9369 9.81524C15.3859 10.1332 15.9262 10.6335 16.6462 11.3535L17.3533 10.6464C16.6338 9.92692 16.0404 9.37131 15.5147 8.9991C14.9864 8.62504 14.4709 8.39559 13.9138 8.41203C13.3599 8.42838 12.8626 8.68533 12.3652 9.0619C11.8693 9.43727 11.3139 9.97874 10.6462 10.6464L11.3533 11.3535ZM16.6462 11.3535C17.369 12.0763 17.8749 12.6109 18.1975 13.057C18.5177 13.4995 18.6108 13.7927 18.6004 14.038C18.5898 14.2912 18.4649 14.5998 18.1072 15.0635C17.7503 15.5262 17.2136 16.079 16.4697 16.8229L17.1768 17.53C17.9114 16.7955 18.4958 16.197 18.899 15.6743C19.3015 15.1525 19.5758 14.6416 19.5996 14.0802C19.6236 13.5109 19.3864 12.9943 19.0077 12.4708C18.6316 11.9508 18.0701 11.3632 17.3533 10.6464L16.6462 11.3535ZM14.4998 16.341L14.4998 14.2197H13.4998L13.4998 16.341H14.4998ZM13.7649 11.8332C13.7649 11.7035 13.8701 11.5983 13.9998 11.5983V12.5983C14.4224 12.5983 14.7649 12.2558 14.7649 11.8332H13.7649ZM13.9998 11.5983C14.1295 11.5983 14.2346 11.7035 14.2346 11.8332H13.2346C13.2346 12.2558 13.5772 12.5983 13.9998 12.5983V11.5983ZM14.2346 11.8332C14.2346 11.9629 14.1295 12.068 13.9998 12.068V11.068C13.5772 11.068 13.2346 11.4106 13.2346 11.8332H14.2346ZM13.9998 12.068C13.8701 12.068 13.7649 11.9629 13.7649 11.8332H14.7649C14.7649 11.4106 14.4224 11.068 13.9998 11.068V12.068Z"
                                    fill="white" />
                            </svg>
                        </span>
                    </div>
                    <!-- <p>icon</p> -->
                    <!-- Login -->
                    <div class="card-body" *ngIf="loginMode">
                        <div class="row d-flex justify-content-center get_started text-center">
                            Sign in
                        </div>

                        <div class="row mt-3" *ngIf="loginStep === 'choose'">
                            <form>
                                <div class="form-input">
                                    <label class="login_label">Email</label>
                                    <div class="input-icons d-flex">
                                        <img draggable="false" class="iconLogin"
                                            src="../../../../assets/email_prefix.svg" />
                                        <input class="login_input pl-5" type="email" [(ngModel)]='username'
                                            placeholder="Enter your email address" name="username"
                                            (input)="onEmailInput($event)" required />
                                    </div>
                                </div>
                                <div class="form-input row error_msg mt-2 mb-2" *ngIf="ssoErrorMessage || message">
                                    {{ ssoErrorMessage || message }}
                                </div>
                                <div class="col-12 mt-3 px-0">
                                    <button
                                        type="button"
                                        class="btn btn-outline-primary login_button sso-login-button"
                                        (click)="chooseOktaLogin()"
                                        [disabled]="!ssoAvailable || isSsoLoggingIn"
                                    >
                                        {{ isSsoLoggingIn ? 'Redirecting…' : 'Login with Okta' }}
                                    </button>
                                </div>
                                <div class="col-12 mt-3 px-0">
                                    <button
                                        type="button"
                                        class="btn btn-primary login_button"
                                        (click)="choosePasswordLogin()"
                                        [disabled]="isSsoLoggingIn"
                                    >
                                        Login with password
                                    </button>
                                </div>
                                <div class="form-input row error_msg mt-2 mb-2" *ngIf="ssoAvailable === false">
                                    Okta SSO is not configured for this environment.
                                </div>
                            </form>
                        </div>

                        <div class="row mt-3" *ngIf="loginStep === 'password'">
                            <form #f="ngForm">
                                <div class="form-input">
                                    <label class="login_label">Email</label>
                                    <div class="input-icons d-flex">
                                        <img draggable="false" class="iconLogin"
                                            src="../../../../assets/email_prefix.svg" />
                                        <input class="login_input pl-5" type="email" [(ngModel)]='username'
                                            placeholder="Enter your email address" name="username"
                                            (input)="onEmailInput($event)" required />
                                    </div>
                                </div>

                                <div class="form-input mt-3">
                                    <label class="login_label">Password</label>
                                    <div class="input-icons d-flex">
                                        <img draggable="false" class="iconLogin"
                                            src="../../../../assets/password_login.svg" />
                                        <input class="login_input pl-5" type="{{ showPassword ? 'text' : 'password' }}"
                                            type="password" [(ngModel)]='password' placeholder="Enter password"
                                            name="newPassword" required />
                                        <img draggable="false" (click)="togglePasswordVisibility()" class="iconLogin"
                                            [src]="showPassword ? '../../../../assets/eye.svg' : '../../../../assets/eyeoff_login.svg'"
                                            style="position: absolute; right: 0" />
                                    </div>
                                </div>

                                <div class="form-input row error_msg mt-2 mb-2">
                                    {{message}}
                                </div>

                                <div class="row align-items-center">
                                    <div class="col-6 text-left d-flex">
                                        <input type="checkbox" [checked]="rememberMe"
                                            (change)="onRememberMeChange($event)" />
                                        <span class="remember_me_login ml-2">Remember Me</span>
                                    </div>
                                    <div class="col-6 text-right">
                                        <a class="forgot_password_link" href="javascript:void(0)"
                                            (click)="showResetPassword()">Forgot Password</a>
                                    </div>
                                </div>

                                <div class="row mt-3">
                                    <div class="col-12">
                                        <button type="submit" class="btn btn-primary login_button" (click)="login(f)" [disabled]="isLoggingIn">
                                            Login
                                        </button>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12 text-center">
                                        <a class="forgot_password_link" href="javascript:void(0)"
                                            (click)="backToLoginChooser()">Back</a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <!-- set MFA Preference for Existing User -->
                    <div class="card-body" *ngIf="existingMFAPreferenceUpdate">
                        <div class="row d-flex justify-content-center get_started text-center">
                            Update MFA Preference
                        </div>


                        <div class="row mt-3">
                            <label class="login_label">Your Current MFA Preference is: {{methodName}}.</label>
                            <div class="row align-items-center mt-3">
                                <div class="col-6 text-left d-flex">
                                    <input class="radio-btn" type="radio" name="setupMethod" [(ngModel)]="setupMethod"
                                        value="TOTP" required />
                                    <span class="remember_me_login ml-2">Set up with
                                        <strong>Authenticator</strong></span>
                                </div>
                                <div class="col-6 text-left d-flex">
                                    <input class="radio-btn" type="radio" name="setupMethod" [(ngModel)]="setupMethod"
                                        value="EMAIL" required />
                                    <span class="remember_me_login ml-2">Set up with <strong>Email OTP</strong></span>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-12">
                                    <button type="submit" class="login_button btn btn-primary"
                                        (click)="updatePreference()">Update Preference</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- MFA Verification -->
                    <div class="card-body" *ngIf="mfaMode">
                        <!-- <div class="row get_started">
                            Get started now
                        </div> -->
                        <!-- <div class="row mt-2 get_started_subheading">
                            Enter credentials to login into your account
                        </div> -->
                        <div class="row mt-3">
                            <form>
                                <div *ngIf="showQR">
                                    <div>Please scan this code to setup MFA</div>
                                    <qrcode *ngIf="qrValue" [qrdata]="qrValue" [width]="128"
                                        [errorCorrectionLevel]="'M'"></qrcode>

                                    <div>(Or enter manually)</div>

                                    <div class="mb-4 mt-2">
                                        <p class="m-0 d-flex align-items-center login_label_du" style="gap: 5px;">
                                            <strong style="white-space: nowrap;">Account Name:</strong>
                                            <span
                                                style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{
                                                accountName || this.username }} </span>
                                            <button mat-icon-button type="button"
                                                (click)="copyToClipboard(accountName || this.username)"
                                                class="copy-button" matTooltipPosition="above"
                                                [matTooltip]="!copied ? 'Copy' : 'Copied'">
                                                <ng-container *ngIf="!copied; else copiedIcon">
                                                    <!-- Copy Icon -->
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                                        fill="currentColor" viewBox="0 0 24 24">
                                                        <path
                                                            d="M16 1H4C2.9 1 2 1.9 2 3v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                                                    </svg>
                                                </ng-container>

                                                <ng-template #copiedIcon>
                                                    <!-- Static Tick Icon -->
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                                        fill="currentColor" viewBox="0 0 24 24">
                                                        <path d="M9 16.2l-4.2-4.2-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                                                    </svg>
                                                </ng-template>
                                            </button>
                                        </p>
                                        <p class="m-0 d-flex align-items-center login_label_du" style="gap: 5px;">
                                            <strong style="white-space: nowrap;">Secret Key:</strong>
                                            <span
                                                style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{
                                                secretKey }} </span>
                                            <button mat-icon-button type="button" (click)="copyToAClipboard(secretKey)"
                                                class="copy-button" matTooltipPosition="above"
                                                [matTooltip]="!copiedA ? 'Copy' : 'Copied'">
                                                <ng-container *ngIf="!copiedA; else copiedIconA">
                                                    <!-- Copy Icon -->
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                                        fill="currentColor" viewBox="0 0 24 24">
                                                        <path
                                                            d="M16 1H4C2.9 1 2 1.9 2 3v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                                                    </svg>
                                                </ng-container>

                                                <ng-template #copiedIconA>
                                                    <!-- Static Tick Icon -->
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                                        fill="currentColor" viewBox="0 0 24 24">
                                                        <path d="M9 16.2l-4.2-4.2-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                                                    </svg>
                                                </ng-template>
                                            </button>
                                        </p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 login_label mb-1">Enter Verification Code</div>
                                    <div class="col-12">
                                        <input #verificationCodeInput class="login_input w-50" type="text" [(ngModel)]="mfa_answer"
                                            name="verificationCode" autocomplete="off" required />
                                    </div>
                                    <div class="col-12 error_msg mt-2 mb-2">{{ mfaMessage }}</div>
                                </div>
                                <div class="row" style="margin: 0 !important;">
                                    <button type="submit" class="btn btn-primary verify_mfa_button w-25"
                                        (click)="verifyMFA()">
                                        Verify MFA
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <!-- email Verification code -->
                    <div class="card-body" *ngIf="ConfirmMFaMode">
                        <!-- <div class="row get_started">
                            Get started now
                        </div> -->
                        <!-- <div class="row mt-2 get_started_subheading">
                            Enter credentials to login into your account
                        </div> -->
                        <div class="row mt-3">
                            <form>
                                <div class="row">
                                    <div class="col-12 login_label mb-1">Enter Verification Code</div>
                                    <div class="col-12">
                                        <input #verificationCodeInput class="login_input w-50" type="text" [(ngModel)]="mfa_answer"
                                            name="verificationCode" autocomplete="off" required />
                                    </div>
                                    <div class="col-12 error_msg mt-2 mb-2">{{ mfaMessage }}</div>
                                </div>
                                <div class="row" style="margin: 0 !important;">
                                    <button type="submit" class="btn btn-primary verify_mfa_button w-25"
                                        (click)="confirmMFA()">
                                        Verify MFA
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <!-- first time for Mfa set up email valide  -->
                    <div class="card-body" *ngIf="firstTimeEmailCodeMFA">
                        <div class="row mt-3">
                            <form>
                                <div class="row">
                                    <div class="col-12 login_label mb-1">Enter Verification Code</div>
                                    <div class="col-12">
                                        <input #verificationCodeInput class="login_input w-50" type="text" [(ngModel)]="mfa_answer"
                                            name="verificationCode" autocomplete="off" required />
                                    </div>
                                    <div class="col-12 error_msg mt-2 mb-2">{{ mfaMessage }}</div>
                                </div>
                                <div class="row" style="margin: 0 !important;">
                                    <button type="submit" class="btn btn-primary verify_mfa_button w-25"
                                        (click)="validateEmailCode()">
                                        Verify Email OTP
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <!-- Forgot Password -->
                    <div class="card-body" *ngIf="forgotMode">
                        <div class="row get_started">
                            Forgot your password?
                        </div>
                        <div class="row mt-2 get_started_subheading">
                            Please provide your registered email to get the instructions to reset your password
                        </div>
                        <div class="row mt-3">
                            <form #f="ngForm">
                                <div class="form-input">
                                    <label class="login_label">Email</label>
                                    <div class="input-icons d-flex">
                                        <img draggable="false" class="iconLogin"
                                            src="../../../../assets/email_prefix.svg" />
                                        <input class="login_input pl-5" type="email" [(ngModel)]='forgot_email'
                                            placeholder="Enter your email" name="forgotEmail" required />
                                    </div>
                                </div>

                                <div class="form-input row error_msg mt-2 mb-2">
                                    {{forgotErrorMessage}}
                                </div>

                                <div class="row mt-3">
                                    <div class="col-12">
                                        <button type="submit" class="login_button btn btn-primary"
                                            (click)="sendVerificationCode()">
                                            Send Verification Link
                                        </button>
                                    </div>
                                </div>

                                <div class="row mt-4">
                                    <div class="col-12 d-flex justify-content-center">
                                        <a class="back_to_login pl-1" href="javascript:void(0)"
                                            (click)="showLogin()">Back to login</a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <!-- Reset Password -->
                    <div class="card-body" *ngIf="resetMode">
                        <div class="row get_started">
                            Email Sent successfully!!
                        </div>
                        <div class="row mt-2 get_started_subheading">
                            Two emails have been sent to you- one includes a verification code and the other contains a
                            reset link.
                        </div>
                        <div class="row mt-3">
                            <!-- <form #f="ngForm">
                                <div class="form-input">
                                    <label class="login_label">Enter Verification Code</label>
                                    <div class="input-icons d-flex">
                                        <input class="login_input" type="text" [(ngModel)]='verification_code'
                                            placeholder="Enter verification code" name="verificationCode" required />
                                    </div>
                                </div>

                                <div class="form-input mt-3">
                                    <label class="login_label">New Password</label>
                                    <div class="input-icons d-flex">
                                        <img class="iconLogin" src="../../../../assets/password_login.svg" />
                                        <input class="login_input pl-5" type="{{ showPassword ? 'text' : 'password' }}"
                                            [(ngModel)]='new_update_password' placeholder="Enter new password"
                                            name="newPassword" required />
                                        <img (click)="togglePasswordVisibility()" class="iconLogin"
                                            [src]="!showPassword ? '../../../../assets/eye.svg' : '../../../../assets/eyeoff_login.svg'"
                                            style="position: absolute; right: 0" />
                                    </div>
                                </div>

                                <div class="form-input row error_msg mt-2 mb-2">
                                    {{updatePasswordMessage}}
                                </div>

                                <div class="row mt-3">
                                    <div class="col-12">
                                        <button type="submit" class="login_button btn btn-primary"
                                            (click)="updatePassword()">
                                            Reset Password
                                        </button>
                                    </div>
                                </div>

                                <div class="row mt-4">
                                    <div class="col-12 d-flex justify-content-center">
                                        <a class="back_to_login pl-1" href="javascript:void(0)"
                                            (click)="showLogin()">Back to login</a>
                                    </div>
                                </div>
                            </form> -->
                        </div>
                    </div>
                    <!-- Reset Password -->
                    <div class="card-body" *ngIf="isResetPasswordSuccess">
                        <div class="row get_started">
                            Success!!
                        </div>
                        <div class="row mt-3">
                            <div class="col-12">Your Password has been reset successfully.</div>
                            <div class="col-12 mt-3" style="color: blue;">Redirecting back to Login Screen...</div>
                        </div>
                    </div>
                    <!-- First Time Reset Password -->
                    <div class="card-body" *ngIf="firstTimeReset">
                        <div class="get_started">
                            Reset password
                        </div>
                        <div class="mt-2 get_started_subheading">
                            Create new password to your account.
                        </div>
                        <div class="mt-3">
                            <form #f="ngForm">
                                <div class="form-input mt-3">
                                    <label class="login_label">New Password</label>
                                    <div class="input-icons d-flex">
                                        <img draggable="false" class="iconLogin"
                                            src="../../../../assets/password_login.svg" />
                                        <input class="login_input pl-5" type="{{ showPassword ? 'text' : 'password' }}"
                                            [(ngModel)]='new_password' placeholder="Enter new password"
                                            name="newPassword" required />
                                        <img draggable="false" (click)="togglePasswordVisibility()" class="iconLogin"
                                            [src]="showPassword ? '../../../../assets/eye.svg' : '../../../../assets/eyeoff_login.svg'"
                                            style="position: absolute; right: 0" />
                                    </div>
                                </div>

                                <div class="form-input mt-3">
                                    <label class="login_label">Confirm New Password</label>
                                    <div class="input-icons d-flex">
                                        <img draggable="false" class="iconLogin"
                                            src="../../../../assets/password_login.svg" />
                                        <input class="login_input pl-5"
                                            type="{{ showConfirmPassword ? 'text' : 'password' }}"
                                            [(ngModel)]='confirm_password' placeholder="Enter confirm password"
                                            name="confirmPassword" required />
                                        <img draggable="false" (click)="toggleConfirmPasswordVisibility()"
                                            class="iconLogin"
                                            [src]="showConfirmPassword ? '../../../../assets/eye.svg' : '../../../../assets/eyeoff_login.svg'"
                                            style="position: absolute; right: 0" />
                                    </div>
                                </div>

                                <div class=" form-input row error_msg mt-2 mb-2">
                                    {{messageResetPassword}}
                                </div>
                                <label class="login_label">Select Verification Method</label>
                                <div class="row align-items-center">
                                    <div class="col-6 text-left d-flex">
                                        <input class="radio-btn" type="radio" name="setupMethod"
                                            [(ngModel)]="setupMethod" value="EMAIL" required />
                                        <span class="remember_me_login ml-2">Set up with <strong>Email
                                                OTP</strong></span>
                                    </div>
                                    <div class="col-6 text-left d-flex">
                                        <input class="radio-btn" type="radio" name="setupMethod"
                                            [(ngModel)]="setupMethod" value="TOTP" required />
                                        <span class="remember_me_login ml-2">Set up with
                                            <strong>Authenticator</strong></span>
                                    </div>

                                </div>
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <button type="submit" class="login_button btn btn-primary"
                                            (click)="resetPassword()">
                                            Reset Password
                                        </button>
                                    </div>
                                </div>

                                <div class="row mt-4">
                                    <div class="col-12 d-flex justify-content-center">
                                        <a class="back_to_login pl-1" href="javascript:void(0)"
                                            (click)="showLogin()">Back to login</a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <!-- First Time Set MFA or Email OTP -->
                    <div class="card-body" *ngIf="firstTimeSetup">
                        <div class="get_started">Setup Authentication</div>
                        <div class="mt-2 get_started_subheading">
                            Choose how you want to secure your account.
                        </div>

                        <div class="mt-3">
                            <form #f="ngForm">
                                <!-- Radio options -->
                                <div class="form-input mt-3">
                                    <label class="login_label">Select Verification Method</label>

                                    <div class="form-check">
                                        <label class="radio-option">
                                            <input type="radio" name="setupMethod" [(ngModel)]="setupMethod"
                                                value="TOTP" required />
                                            <span class="pad-left-25">Set up with <strong>MFA</strong></span>
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <label class="radio-option">
                                            <input type="radio" name="setupMethod" [(ngModel)]="setupMethod"
                                                value="EMAIL" required />
                                            <span class="pad-left-25">Set up with <strong>Email OTP</strong></span>
                                        </label>
                                    </div>

                                </div>

                                <div class="form-input row error_msg mt-2 mb-2">
                                    {{ messageResetPassword }}
                                </div>

                                <div class="row mt-3">
                                    <div class="col-12">
                                        <button type="submit" class="login_button btn btn-primary w-100"
                                            [disabled]="!setupMethod" (click)="confirmSetup()">
                                            Confirm
                                        </button>
                                    </div>
                                </div>

                                <div class="row mt-4">
                                    <div class="col-12 d-flex justify-content-center">
                                        <a class="back_to_login pl-1" href="javascript:void(0)"
                                            (click)="showLogin()">Back to login</a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <!-- Email Verification OTP -->
                    <div class="card-body" *ngIf="emailMode">
                        <div class="row mt-3">
                            <form>

                                <div class="row">
                                    <div class="col-12 login_label mb-1">Enter Email Verification Code</div>
                                    <div class="col-12">
                                        <input class="login_input w-50" type="text" [(ngModel)]="email_otp"
                                            name="verificationCode" autocomplete="off" required />
                                    </div>
                                    <div class="mt-3 col-12" *ngIf="isResendDisabled">Resend OTP available in {{ timer
                                        }}s</div>
                                    <div class="col-12 error_msgs mt-2 mb-2">{{ emailMessage }}</div>
                                    <div *ngIf="message" style="color: #1363df" class="col-12 mt-2 mb-2">{{ message }}
                                    </div>
                                </div>
                                <div class="row" style="margin: 0 !important;">
                                    <button type="submit" class="btn btn-primary verify_mfa_button w-25"
                                        (click)="verifyEmailCode()">
                                        Verify Email OTP
                                    </button>
                                </div>
                                <div *ngIf="!isResendDisabled" class="row mt-3 align-items-center">
                                    <div class="col-6 text-left d-flex">
                                        <a class="forgot_password_link" href="javascript:void(0)"
                                            (click)="resendEmailOtp()">Didn't receive OTP? <strong>Resend</strong>
                                            OTP</a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
            <!-- FOOTER -->
            <div class="row d-flex justify-content-center footer">
                <div class="mb-2">Copyright © 2026 All Rights Reserved by <b>Data Unveil</b></div>
            </div>
        </div>
        <!-- Login Side Image -->
        <!-- <div class="du_login_img col-lg-6 col-xs-12 col-sm-12 col-md-6"> -->
        <!-- <img src="../../../../assets/loginPageBg.svg" style="height: 100vh;" /> -->
        <!-- </div> -->
        <div class="col-lg-6 col-xs-12 col-sm-12 col-md-6">
            <img draggable="false" class="du_login_newIMG" *ngFor="let image of images; let i = index" [src]="image"
                alt="Slide {{ i }}" [@fadeAnimation]="currentImageIndex === i"
                [style.z-index]="currentImageIndex === i ? 1 : 0" />
            <!-- <img src="../../../../assets/loginPageBg.svg" style="height: 100vh;" /> -->
        </div>
    </div>
</div>

<mat-menu #info="matMenu">
    <div class="card" style="width: 500px;border: none;width: auto !important;" (click)="$event.stopPropagation()">
        <div class="card-header d-flex justify-content-between align-items-center"
            style="border-bottom: none;background: #ddd;">
            <span style="font-weight: 600;">{{'Help Info'}}</span>

            <span (click)="closeMenu()" mat-dialog-close>
                <svg width="16" height="16" style="width: 12px !important;height: 12px !important;" viewBox="0 0 16 16"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12.9501 0.409871L8 5.35998L3.04989 0.409871C2.5034 -0.136624 1.61634 -0.136624 1.06985 0.409871L0.409871 1.06985C-0.136624 1.61634 -0.136624 2.5034 0.409871 3.04989L5.35998 8L0.409871 12.9501C-0.136624 13.4966 -0.136624 14.3837 0.409871 14.9302L1.06985 15.5901C1.61634 16.1366 2.5034 16.1366 3.04989 15.5901L8 10.64L12.9501 15.5901C13.4966 16.1366 14.3837 16.1366 14.9302 15.5901L15.5901 14.9302C16.1366 14.3837 16.1366 13.4966 15.5901 12.9501L10.64 8L15.5901 3.04989C16.1366 2.5034 16.1366 1.61634 15.5901 1.06985L14.9302 0.409871C14.3837 -0.136624 13.4966 -0.136624 12.9501 0.409871Z"
                        fill="#1363DF" />
                </svg>
            </span>
        </div>

        <div style="padding-top: 8px;">
            <div style="padding: 0 15px;" [innerHTML]="helpinfoMessage"></div>
        </div>
    </div>
</mat-menu>